/**
 * Generated from ch4_p09.fla
 */
export function ch4_p09(this: Ich4_p09) {
	const bg = this.bg;
	ch4_p09_hh_ch4_p09psdAssetchp4_p09_bg.call(this.bg);
	bg.x = 832;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	bg.alpha = 1.00;
	if (bg.onLayout) bg.onLayout();
	const phone = this.phone;
	ch4_p09_hh_ch4_p09psdAssetchp4_p09_phone.call(this.phone);
	phone.x = 950.5;
	phone.y = 384;
	phone.width = 1341.00;
	phone.height = 768.00;
	phone.alpha = 1.00;
	if (phone.onLayout) phone.onLayout();
	const notification = this.notification;
	ch4_p09_hh_ch4_p09psdAssetchp4_p09_notification.call(this.notification);
	notification.x = 838.25;
	notification.y = 371.75;
	notification.width = 298.50;
	notification.height = 148.50;
	notification.alpha = 1.00;
	if (notification.onLayout) notification.onLayout();
	const shine = this.shine;
	ch4_p09_hh_ch4_p09psdAssetchp4_p09_shine.call(this.shine);
	shine.x = 869.25;
	shine.y = 401.5;
	shine.width = 409.50;
	shine.height = 563.00;
	shine.alpha = 1.00;
	if (shine.onLayout) shine.onLayout();
	const frameRight = this.frameRight;
	ch4_p09_hh_ch4_p09psdAssetchp4_p09_wcframeL.call(this.frameRight);
	frameRight.x = 1664;
	frameRight.y = 384;
	frameRight.width = 356.00;
	frameRight.height = 768.00;
	frameRight.alpha = 1.00;
	if (frameRight.onLayout) frameRight.onLayout();
	const frameLeft = this.frameLeft;
	ch4_p09_hh_ch4_p09psdAssetchp4_p09_wcframeR.call(this.frameLeft);
	frameLeft.x = 0;
	frameLeft.y = 384;
	frameLeft.width = 344.00;
	frameLeft.height = 768.00;
	frameLeft.alpha = 1.00;
	if (frameLeft.onLayout) frameLeft.onLayout();
	return this;
}
function ch4_p09_hh_ch4_p09psdAssetchp4_p09_bg(this: Ich4_p09_hh_ch4_p09psdAssetchp4_p09_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp4_p09_bg", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p09_hh_ch4_p09psdAssetchp4_p09_phone(this: Ich4_p09_hh_ch4_p09psdAssetchp4_p09_phone) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp4_p09_phone", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p09_hh_ch4_p09psdAssetchp4_p09_notification(this: Ich4_p09_hh_ch4_p09psdAssetchp4_p09_notification) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp4_p09_notification", 0.500, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p09_hh_ch4_p09psdAssetchp4_p09_shine(this: Ich4_p09_hh_ch4_p09psdAssetchp4_p09_shine) {
	if (this.setLayoutTexture) this.setLayoutTexture("chp4_p09_shine.png", 0.551, 0.500);
	if (this.setBlendMode) this.setBlendMode("normal");
	return this;
}
function ch4_p09_hh_ch4_p09psdAssetchp4_p09_wcframeL(this: Ich4_p09_hh_ch4_p09psdAssetchp4_p09_wcframeL) {
	if (this.setLayoutTexture) this.setLayoutTexture("L", 1.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
function ch4_p09_hh_ch4_p09psdAssetchp4_p09_wcframeR(this: Ich4_p09_hh_ch4_p09psdAssetchp4_p09_wcframeR) {
	if (this.setLayoutTexture) this.setLayoutTexture("R", 0.000, 0.500);
	if (this.setBlendMode) this.setBlendMode("screen");
	return this;
}
interface Ich4_p09Array<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface Ich4_p09Container {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface Ich4_p09Sprite extends Ich4_p09Container {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
	alpha: number;
	setBlendMode?(blendMode: string): void;
}
interface Ich4_p09Text extends Ich4_p09Container {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface Ich4_p09Polygon extends Array<number> {
}
interface Ich4_p09 {
	readonly bg: Ich4_p09_hh_ch4_p09psdAssetchp4_p09_bg;
	readonly phone: Ich4_p09_hh_ch4_p09psdAssetchp4_p09_phone;
	readonly notification: Ich4_p09_hh_ch4_p09psdAssetchp4_p09_notification;
	readonly shine: Ich4_p09_hh_ch4_p09psdAssetchp4_p09_shine;
	readonly frameRight: Ich4_p09_hh_ch4_p09psdAssetchp4_p09_wcframeL;
	readonly frameLeft: Ich4_p09_hh_ch4_p09psdAssetchp4_p09_wcframeR;
}
interface Ich4_p09_hh_ch4_p09psdAssetchp4_p09_bg extends Ich4_p09Sprite {
}
interface Ich4_p09_hh_ch4_p09psdAssetchp4_p09_phone extends Ich4_p09Sprite {
}
interface Ich4_p09_hh_ch4_p09psdAssetchp4_p09_notification extends Ich4_p09Sprite {
}
interface Ich4_p09_hh_ch4_p09psdAssetchp4_p09_shine extends Ich4_p09Sprite {
}
interface Ich4_p09_hh_ch4_p09psdAssetchp4_p09_wcframeL extends Ich4_p09Sprite {
}
interface Ich4_p09_hh_ch4_p09psdAssetchp4_p09_wcframeR extends Ich4_p09Sprite {
}
